module.exports = __webpack_public_path__ + "img/批量变更数据.7c4c5bef.svg";